import Header from "../components/sections/Header";
import Hero from "../components/sections/Hero";
import Marquee from "../components/sections/Marquee";
import Products from "../components/sections/Products";
import WhyUs from "../components/sections/WhyUs";
import Testimonials from "../components/sections/Testimonials";
import HowItWorks from "../components/sections/HowItWorks";
import ApplicationForm from "../components/sections/ApplicationForm";
import FAQ from "../components/sections/FAQ";
import ProfitProtector from "../components/sections/ProfitProtector";
import Footer from "../components/sections/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Header />
      <Hero />
      <Marquee />
      <Products />
      <ProfitProtector />
      <WhyUs />
      <Testimonials />
      <HowItWorks />
      <ApplicationForm />
      <FAQ />
      <Footer />
    </main>
  );
}
